import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";
import { QuestionForm } from "./QuestionFormTypes";

export interface CvpGetAnswersResponse extends BackendResponse {
  items: AnswersDto[];
}

export interface CvpGetAnswersParameters extends NextApiParams {
  questionId?: number; //Id of question
  questionOptionId?: number; //Id of question option. Leave this as null to obtain all answers to a question.
  questionFormLogId?: number; //Id of question answering instance.
}

export const getAnswers = withNextApi<
  CvpGetAnswersResponse,
  CvpGetAnswersParameters
>("/cvp/CvpGetAnswers", { method: "GET" });

export interface AnswersDto {
  id: number | null;
  relatedId: number;
  relatedType: number;
  questionId: number;
  questionOptionId: number;
  numberAnswer: number | null;
  stringAnswer: string;
  questionFormLog: number;
  clearAnswersFirst: boolean;
}
